/* ==========================================================================
   NEW HERO / BANNER SLIDESHOW — behaviour
   Vanilla JS, no external library. Handles: autoplay, dot navigation,
   touch swipe, desktop mouse drag, trackpad horizontal swipe, and pausing
   on hover/focus/when the tab isn't visible.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-new-hero-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.new-hero-slide'));
    var dotsWrap = slider.querySelector('[data-new-hero-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.new-hero-dot')) : [];

    var slideCount = slides.length;
    if (slideCount <= 1) return; // nothing to animate for a single slide

    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 5000;

    var current = 0;
    var timer = null;

    function goTo(index) {
      index = (index + slideCount) % slideCount;
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = index;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(next, speed);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Dot navigation
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start(); // restart the autoplay timer after a manual click
      });
    });

    // Pause on hover / keyboard focus
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    // Pause when the browser tab isn't visible
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    // Touch swipe
    var touchStartX = 0;
    var touchDeltaX = 0;

    slider.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
        stop();
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      function (e) {
        touchDeltaX = e.touches[0].clientX - touchStartX;
      },
      { passive: true }
    );

    slider.addEventListener('touchend', function () {
      var threshold = 40;
      if (touchDeltaX > threshold) {
        goTo(current - 1);
      } else if (touchDeltaX < -threshold) {
        goTo(current + 1);
      }
      start();
    });

    /* ------------------------------------------------------------------ */
    /* DESKTOP: mouse drag                                                */
    /* Touch events mouse se nahi bante, isliye desktop par alag handler  */
    /* ------------------------------------------------------------------ */
    var DRAG_THRESHOLD = 50;
    var mouseDown = false;
    var dragMoved = false;
    var mouseStartX = 0;
    var mouseStartY = 0;

    slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (e.target.closest('.new-hero-dot')) return; // dots ka apna click chalne do
      mouseDown = true;
      dragMoved = false;
      mouseStartX = e.clientX;
      mouseStartY = e.clientY;
      slider.classList.add('is-dragging');
      e.preventDefault(); // image ghost-drag aur text selection band
    });

    document.addEventListener('mousemove', function (e) {
      if (!mouseDown) return;
      if (Math.abs(e.clientX - mouseStartX) > 5) dragMoved = true;
    });

    document.addEventListener('mouseup', function (e) {
      if (!mouseDown) return;
      mouseDown = false;
      slider.classList.remove('is-dragging');

      var dx = e.clientX - mouseStartX;
      var dy = e.clientY - mouseStartY;

      if (Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        goTo(dx < 0 ? current + 1 : current - 1);
        start();
      }
    });

    // drag ke baad banner ka link / button na khule
    slider.addEventListener(
      'click',
      function (e) {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      },
      true
    );

    /* ------------------------------------------------------------------ */
    /* DESKTOP: trackpad / horizontal mouse wheel                         */
    /* Sirf horizontal swipe par chalta hai, vertical page scroll nahi    */
    /* ------------------------------------------------------------------ */
    var wheelLock = false;

    slider.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaX) < 20 || Math.abs(e.deltaX) < Math.abs(e.deltaY)) return;
        e.preventDefault();
        if (wheelLock) return;
        wheelLock = true;
        goTo(e.deltaX > 0 ? current + 1 : current - 1);
        start();
        setTimeout(function () {
          wheelLock = false;
        }, 600);
      },
      { passive: false }
    );

    start();
  });
});